var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ClockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 16.25 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #232323;\n        stroke: #232323;\n        stroke-width: 0.25px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-clock",
    className: "cls-1",
    d: "M12,4a8,8,0,1,0,8,8A8.009,8.009,0,0,0,12,4Zm0,1.2A6.8,6.8,0,1,1,5.2,12,6.791,6.791,0,0,1,12,5.2Zm-.209,1.991A.6.6,0,0,0,11.2,7.8v4.8a.6.6,0,0,0,.6.6H15A.6.6,0,1,0,15,12H12.4V7.8a.6.6,0,0,0-.609-.609Z",
    transform: "translate(-3.875 -3.875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ClockBlack);
export default __webpack_public_path__ + "static/media/icons8-clock-black.eed0110d642d27764fa6ba26e60808b8.svg";
export { ForwardRef as ReactComponent };